import { Text, rawString, type LanguageCore } from '../Language/Language';
import { Button } from '@repo/ui/Button';
import s from './FullscreenError.module.css';
import { clsx } from 'clsx';
import { Flex } from '@repo/ui/Flex';

/*
  Example strings for full experience:

  "pdx.error.primary_url": "/",
  "pdx.error.primary_button": "Back to Home",

  "pdx.error.secondary_button": "Search Peninsula",
  "pdx.error.secondary_url": "https://peninsulatrading.co/search",

  "pdx.error.image_url": "https://storage.googleapis.com/narvar-prod20-freighter-assets/narvarreturns/2cdfe912-de04-4074-9102-902fed9def3f",
 */

export const FullscreenError = ({
  title = { langKey: 'pdx.error.title' },
  description = { langKey: 'pdx.error.description' },
  secondaryButtonTitle = { langKey: 'pdx.error.secondary_button' },
  secondaryButtonUrl = { langKey: 'pdx.error.secondary_url' },
  primaryButtonTitle = { langKey: 'pdx.error.primary_button' },
  primaryButtonUrl = { langKey: 'pdx.error.primary_url' },
  imageUrl = { langKey: 'pdx.error.image_url' },
}: {
  title?: LanguageCore;
  description?: LanguageCore;
  secondaryButtonTitle?: LanguageCore;
  secondaryButtonUrl?: LanguageCore;
  primaryButtonTitle?: LanguageCore;
  primaryButtonUrl?: LanguageCore;
  imageUrl?: LanguageCore;
} = {}) => {
  const imgSrc = rawString(imageUrl);
  const secondaryUrl = rawString(secondaryButtonUrl);
  const primaryUrl = rawString(primaryButtonUrl);
  return (
    <Flex
      className={clsx([s.container, imgSrc && s.withImage])}
      direction="row"
      alignItems="center"
      justifyContent="center"
      gap="g-24"
      grow="1"
    >
      {imgSrc && (
        <Flex className={s.right} justifyContent="center" alignItems="center">
          <img className={s.image} src={imgSrc} alt="Not found" />
        </Flex>
      )}
      <Flex
        className={s.left}
        direction="column"
        justifyContent="center"
        gap="g-16"
      >
        <h2 className={s.title}>
          <Text {...title} />
        </h2>
        <p className={s.description}>
          <Text {...description} />
        </p>
        <Flex
          className={s.buttons}
          direction="row"
          gap="g-16"
          alignItems="center"
        >
          {secondaryUrl && (
            <Button variant="secondary" asChild>
              <a href={secondaryUrl} target="_blank" rel="noopener noreferrer">
                <Text {...secondaryButtonTitle} />
              </a>
            </Button>
          )}
          {primaryUrl && (
            <Button variant="primary" asChild>
              <a href={primaryUrl} target="_blank" rel="noopener noreferrer">
                <Text {...primaryButtonTitle} />
              </a>
            </Button>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
